import React from 'react';

import { ReactComponent as Refresh } from '../../../../shared/assets/refresh.svg';
import { useGetTaskListQuery } from '../../model/api/tasksApi';
import styles from './TaskReload.module.css';

type Props = {
  onClose: () => void;
};

export const TaskReload: React.FC<Props> = ({ onClose }) => {
  const { refetch } = useGetTaskListQuery();

  const handleClick = () => {
    refetch();
    onClose();
  };

  return (
    <div className={styles.root} onClick={handleClick}>
      <Refresh />
      <span className={styles.text}>Обновить данные</span>
    </div>
  );
};
